import { Flex, FlexProps } from 'antd';

export type AppFlexProps = FlexProps & {
    accessibilityLabel?: string;
};

export const AppFlex = ({ children, accessibilityLabel, ...restProps }: AppFlexProps) => (
    <Flex aria-label={accessibilityLabel} {...restProps}>
        {children}
    </Flex>
);
